function getRoutes() {
  return {
    ROUTE: {
      COLLECTIONS: "collections",
      DETAILS: "details",
    },
  };
}

function getUrl() {
  try {
    const NEW_BASE_APPLICATION = process.env.REACT_APP_BASE_APP_URL;
    const NEW_REFACTORING_URL = process.env.REACT_APP_WORKBENCH_URL;
    const NEW_CONNECTOR_URL = process.env.REACT_APP_CONNECTOR_URL;

    return {
      URL: {
        ORGANISATION: {
          KEY: "organisation",
          GET: NEW_BASE_APPLICATION + "/api/v1/organisation",
          POST: NEW_BASE_APPLICATION + "/api/v1/organisation",
          PUT: NEW_BASE_APPLICATION + "/api/v1/organisation/$id",
          DELETE: NEW_BASE_APPLICATION + "/api/v1/organisation/$id",
        },
        SWAGGER: {
          KEY: "swagger",
          GET: NEW_REFACTORING_URL + "/api/swagger-document",
        },
        CONNECT_SWAGGER: {
          KEY: "swagger",
          GET: NEW_CONNECTOR_URL + "/api/swagger-documentation",
        },
        CLIENT_API_KEY: {
          KEY: "client-api",
          GET: NEW_BASE_APPLICATION + "/api/v1/client-api",
          POST: NEW_BASE_APPLICATION + "/api/v1/client-api",
          DELETE: NEW_BASE_APPLICATION + "/api/v1/client-api/$id",
          REQUEST_LOG: NEW_BASE_APPLICATION + "/api/v1/apiKey-logs",
          SEARCH_OPTIONS:
            NEW_BASE_APPLICATION + "/api/v1/client-api/search/options",
          SEARCH_LIST:
            NEW_BASE_APPLICATION +
            "/api/v1/client-api/search/$key/$value?pageSize=$pageSize&page=$page",
        },
        UM: {
          GET: NEW_BASE_APPLICATION + "/api/v1/user",
          POST: NEW_BASE_APPLICATION + "/api/v1/user",
          PUT: NEW_BASE_APPLICATION + "/api/v1/user/$id",
          DELETE: NEW_BASE_APPLICATION + "/api/v1/user/$id",
        },
        AUTH0: {
          BASE_URL: NEW_BASE_APPLICATION,
          KEY: "auth0",
          USER_INFO: NEW_BASE_APPLICATION + "/api/v1/access/access",
        },
        WORKQUEUES: {
          URL: NEW_REFACTORING_URL,
          BASE_URL: NEW_REFACTORING_URL + "/api/workqueues",
          KEY: "workqueues",
        },
        DOCUMENT_EXTRACTION_SETUP: {
          GET: NEW_REFACTORING_URL + "/api/document-extractor",
          POST: NEW_REFACTORING_URL + "/api/document-extractor",
          PUT: NEW_REFACTORING_URL + "/api/document-extractor/$id",
          DELETE: NEW_REFACTORING_URL + "/api/document-extractor/$id",
        },
        CHATBOT: {
          BASE_URL: NEW_BASE_APPLICATION,
          key: "chatbot",
        },
        UPLOAD_FILE: {
          GET: NEW_BASE_APPLICATION + "/api/v1/files/download/$id",
          POST: NEW_BASE_APPLICATION + "/api/v1/files/upload",
          DELETE: NEW_BASE_APPLICATION + "/api/v1/files/delete/$id",
        },
        SUBSCRIPTION_MANAGER: {
          BASE_URL: NEW_BASE_APPLICATION + "/api/v1/subscription-data",
          BY_ID: NEW_BASE_APPLICATION + "/api/v1/subscription-data/$id",
          key: "model",
        },
        BILLING_CENTER_URL: {
          BASE_URL: NEW_BASE_APPLICATION + "/api/v1/billing-dashboard",
          key: "billingDashboard",
        },
        HISTORY: {
          BASE_URL: NEW_BASE_APPLICATION + "/api/v1/billings",
          key: "model",
        },
        MODEL: {
          BASE_URL: NEW_REFACTORING_URL + "/api/extraction-model",
          BY_ID: NEW_REFACTORING_URL + "/api/extraction-model/$id",
          key: "model",
        },
        SMART_QUEUE: {
          BASE_URL: NEW_REFACTORING_URL + "/api/smart-queue",
          BY_ID: NEW_REFACTORING_URL + "/api/smart-queue/$id",
          key: "smart-queue",
        },
        SMART_CLASSES: {
          BASE_URL: NEW_REFACTORING_URL + "/api/smart-classes",
          BY_ID: NEW_REFACTORING_URL + "/api/smart-classes/$id",
          key: "smart-classes",
        },
        EXPORT_CONNECTORS: {
          BASE_URL: NEW_CONNECTOR_URL + "/api/v1/export",
          key: "export-connectors",
        },
        GOOGLE_DRIVE: {
          BASE_URL: NEW_CONNECTOR_URL + "/api/v1/google-drive",
          key: "google-drive",
        },

        AZURE_BLOB: {
          BASE_URL: NEW_REFACTORING_URL + "/api/azureblob",
          KEY: "blob-storage",
        },
        FILESERVICE: {
          GET: NEW_BASE_APPLICATION + "/api/v1/files/download/$id",
          POST: NEW_BASE_APPLICATION + "/api/v1/files/upload",
          DELETE: NEW_BASE_APPLICATION + "/api/v1/files/delete/$id",
          POST_WORKBENCH_UPLOAD: NEW_REFACTORING_URL + "/api/azureblob/upload",
          POST_WORKBENCH_DOWNLOAD:
            NEW_REFACTORING_URL + "/api/azureblob/download",
        },
        CONNECTOR_FILESERVICE: {
          POST: NEW_CONNECTOR_URL + "/api/files/upload",
          GET: NEW_CONNECTOR_URL + "/api/files/download/$id",
          DELETE: NEW_CONNECTOR_URL + "/api/files/delete/$id"
        },
        BRANDING: {
          GET: NEW_BASE_APPLICATION + "/api/v1/branding-details",
          POST: NEW_BASE_APPLICATION + "/api/v1/branding-details",
          PUT: NEW_BASE_APPLICATION + "/api/v1/branding-details/$id",
          DELETE: NEW_BASE_APPLICATION + "/api/v1/branding-details/$id",
          GET_BRANDING:
            NEW_BASE_APPLICATION + "/api/v1/branding-details/domain-url/",
          GET_IMAGES:
            NEW_BASE_APPLICATION + "/api/v1/branding-details/brand-images/",
        },
        ORCHESTRATOR_SERVER: {
          GET: NEW_REFACTORING_URL + "/api/orchestrator-server",
          POST: NEW_REFACTORING_URL + "/api/orchestrator-server",
          PUT: NEW_REFACTORING_URL + "/api/orchestrator-server/$id",
          DELETE: NEW_REFACTORING_URL + "/api/orchestrator-server/$id",
          LIST: NEW_REFACTORING_URL + "/api/orchestrator-server/list",
        },
        IMPORT_CONNECTOR: {
          GET: NEW_CONNECTOR_URL + "/api/v1/import",
        },
        VALUE_HELP: {
          GET: NEW_CONNECTOR_URL + "/api/valueHelp"
        }
      },
    };
  } catch (e) {
    console.warn(e);
  }
}

export { getRoutes, getUrl };
